import * as React from 'react';

import Service from '../../lib/App';
import { isProduction } from '../environment';
import CommonSelect, { CommonSelectWrapperProps } from './CommonSelect';

export interface FacetsSelectProps extends CommonSelectWrapperProps {
  availableFacets?: string[];
  possibleFacets?: string[];
  disabledFacets?: string[];
  shouldFilterFacetsOnlyWhenEventLogDataIsPresent?: boolean;
}

export interface FacetsSelectState {}

export class FacetsSelect extends React.Component<
  FacetsSelectProps,
  FacetsSelectState
> {
  render() {
    const placeholder = this.props.placeholder;
    if (this.props.shouldFilterFacetsOnlyWhenEventLogDataIsPresent) {
      const { availableFacets, possibleFacets, disabledFacets } = this.props;
      let facets = Service.cache!.getAllFacets();
      if (this.props.possibleFacets) {
        facets = facets.filter(({ name }) => possibleFacets.includes(name));
      }

      // available facets
      let facetMetaMap: { [key: string]: any } = {};
      facets.forEach((v) => {
        if (!availableFacets.includes(v.name)) {
          facetMetaMap[v.name] = (
            <div>
              No data for this facet from Variable Stats, please work with your
              Software Engineers to ensure this facet is accurately instrumented
              and deployed ${isProduction ? 3 : 1.5} hours ago for all selected
              variables before continuing with Experimentation setup.{' '}
              <a
                href="https://wiki.grab.com/display/EP/FAQ+%7C+Experiments"
                target="blank"
              >
                wiki
              </a>
            </div>
          );
        }
      });
      return (
        <CommonSelect
          {...this.props}
          values={facets}
          disabledMap={Object.fromEntries(
            disabledFacets.map((val) => [val, true]),
          )}
          metaMap={facetMetaMap}
          useMeta={true}
          idKey="name"
          valueKey="title"
          placeholder={placeholder}
        />
      );
    } else {
      return (
        <CommonSelect
          {...this.props}
          values={Service.cache!.getAllFacets()}
          idKey="name"
          valueKey="title"
          placeholder={placeholder}
        />
      );
    }
  }
}

export default FacetsSelect;
